import Button from '@/common/components/base/button/Button';
import { ButtonType } from '@/common/components/base/button/Button.type';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import { Flex } from 'styled-system/jsx';

const FlowButton = ({
  disabled,
  previousStepHandler,
  loading,
  text = 'تائید و ادامه',
}: {
  disabled: ButtonType['disabled'];
  previousStepHandler: () => void;
  loading?: boolean;
  text?: string;
}) => {
  return (
    <Flex w="100%" gap={16} mt={'4px'}>
      <Button
        type="reset"
        fullWidth
        variant="outlined"
        onClick={previousStepHandler}
      >
        مرحله قبل
      </Button>{' '}
      <Button disabled={disabled} width="100%">
        {loading ? <CircularLoading color="colors.purple-1" /> : text}{' '}
      </Button>
    </Flex>
  );
};

export default FlowButton;
